import React, { useEffect, useState } from "react";
import BarChartComponent from "../../atoms/BarChart";
import PieChartComponent from "../../atoms/PieChart";
import { getSDG } from "../../../utils/API/getSDG";
import { Skeleton } from "antd";
const SdgVisualization = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dataRange, setDataRange] = useState(null);

  useEffect(() => {
    // wrong error handling 
    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await getSDG();
        setDataRange(result[0].data_range);
        const formattedData = result[0].sdg.map((item) => ({
          name: item.name,
          value: item.percentage,
          color: getColor(item.rank),
          colorName: getColorName(item.rank),
          labelLink: `/images/sdgs/${item.ImageNumber}.png`,
        }));
        setData(formattedData);
      } catch (error) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getColor = (rank) => {
    const colors = ["#EB1C2D", "#D3A029", "#4C9F38", "#C52333", "#00AED9"];
    return colors[rank - 1] || "#CCCCCC";
  };

  const getColorName = (rank) => {
    const names = ["red", "yellow", "green", "magenta", "blue"];
    return names[rank - 1] || "gray";
  };

  if (error) return <div>{error}</div>;

  return (
    <div className="flex flex-col shadow-custom w-full bg-white px-4 pt-6 rounded-2xl mt-4">
      <h3 className="font-bold ml-4 text-xs">
        SDGs in Demand <span className="ml-44 text-[10px] text-grey-500 font-medium">{dataRange}</span>
      </h3>
      {loading ? (
        <div className="p-4">
          <Skeleton.Button
            block={true}
            active={true}
            style={{ width: "100%", height: "15rem" }}
          />
        </div>
      ) : (
        <div className="flex items-center">
          <BarChartComponent data={data} />
          <PieChartComponent data={data} />
        </div>
      )}
    </div>
  );
};

export default SdgVisualization;
